import FixedMessage from './fixedMessage'
import Loader from './loader'
import AnimatedProgressBar from './animatedProgressBar'
import ProgressTimeline from './progressTimeline'
import Button from './button'
import CountdownButton from './countdownButton'
import Icon from './icon'
import InfoPill from './infoPill'
import JsonBeforeAfter from './jsonBeforeAfter'
import JsonViewer from './jsonViewer'
import Text, { SIZES } from './text'
import LabelValue from './labelValue'
import Notification from './notification'
import Ribbon from './ribbon'
import MobileRibbon from './mobileRibbon'
import TagDropdown from './tagDropdown'
import Alert from './alert'
import Badge from './badge'
import Money from './money'
import MapPin from './mapPin'
import Pulser from './pulser'
import Filter from './filter'
import MobileFilter from './filter/mobileFilter'
import VerticalExpander from './verticalExpander'
import Animate from './animate'
import SearchFilter from './searchFilter'
import StatusMessage from './statusMessage'
import InitialsAvatar from './initialsAvatar'
import CardContainer from './cardContainer'
import EmptyState from './emptyState'
import Term from './term'
import TermsCard from './termsCard'
import PeriodIndicator from './periodIndicator'

// This is useful in many contexts across our apps, usually when a component slot if dynamic and we want to render
// _something_ there and the calling code isn't configured to use a null value directly since it expects an element.
//
// See `overridableComponents` in the application shell for a good example where this pattern is used.
const NullComponent = () => null
// This is useful when creating dynamic component where the wrapper can be empty and we don't want guard conditions
// since the component is assigned to a dynamic variable. More of a style thing.
const PassthroughComponent: React.FC<{ children: React.ReactElement }> = ({
  children,
}) => children

export {
  AnimatedProgressBar,
  FixedMessage,
  Loader,
  Button,
  CountdownButton,
  Icon,
  InfoPill,
  JsonBeforeAfter,
  JsonViewer,
  Text,
  SIZES,
  Notification,
  Ribbon,
  MobileRibbon,
  TagDropdown,
  Alert,
  Badge,
  NullComponent,
  PassthroughComponent,
  Money,
  MapPin,
  Pulser,
  Filter,
  MobileFilter,
  VerticalExpander,
  Animate,
  SearchFilter,
  StatusMessage,
  LabelValue,
  InitialsAvatar,
  CardContainer,
  EmptyState,
  Term,
  TermsCard,
  PeriodIndicator,
  ProgressTimeline,
}
